jQuery(document).ready(function ($) {

  new Splide('.banner', {
    type: 'fade',
    perPage: 1,
    cover: false,
    arrows: true,
    pagination: false,
    autoHeight: true,
    heightRatio: false,
    gap: 0,
    rewind: true,
    // breakpoints: {
    //   768: {
    //     perPage: 1,
    //     pagination: true
    //   },
    //   1024: {
    //     perPage: 2,
    //     pagination: true
    //   },
    // },
    classes: {
      pagination: 'splide__pagination dots hp-splide__pagination', // container
      arrows: 'splide__arrows hp-splide__arrows',
      arrow: 'splide__arrow hp-splide__arrow',
      prev:
        'splide__arrow--prev hp-splide__arrow--prev',
      next: 'splide__arrow--next hp-splide__arrow--next',
      page: 'splide__pagination__page hp-splide__pagination__page',
    },
  }).mount();


  circlesMask = Object.create({
    name:"circles",
    clipPathDsk:`<path d="M1103.9,0v630H247.3C87.7,450.6,86.8,180.4,245.3,0H1103.9z"></path> <path d="M157,33c-11.2,0-22.2-3.2-31.7-9.2C116,18,108.5,9.8,103.5,0h106.9c-4.9,9.8-12.5,18-21.7,23.8C179.2,29.8,168.2,33,157,33z 	"></path> <path d="M177.3,630H2.7C0.9,622.8,0,615.4,0,608c0-12,2.4-23.9,7.1-35c2.3-5.4,5-10.5,8.3-15.3c3.2-4.8,6.9-9.2,11-13.3 	c4.1-4.1,8.5-7.8,13.3-11c4.8-3.3,9.9-6,15.3-8.3c11.1-4.7,23-7.1,35-7.1s23.9,2.4,35,7.1c5.4,2.3,10.5,5,15.3,8.3 	c4.8,3.2,9.2,6.9,13.3,11c4.1,4.1,7.8,8.5,11,13.3c3.3,4.8,6,9.9,8.3,15.3c4.7,11.1,7.1,23,7.1,35C180,615.4,179.1,622.8,177.3,630 	L177.3,630z"></path> <ellipse cx="107" cy="96.5" rx="20" ry="20.5"></ellipse>`,
    clipPathTblt:`<path id="bkgd" d="M0,42.98S277,0,554,0s554,42.98,554,42.98v481.42s-277,42.98-554,42.98S0,524.4,0,524.4V42.98Z" fill="#80e41c"></path>`,
    clipPathMbl:`<path id="bkgd" d="M0,48.49S200,0,400,0s400,48.49,400,48.49v543.03s-200,48.48-400,48.48S0,591.52,0,591.52V48.49Z" fill="#80e41c"/>`,
    viewBoxDsk:"0 0 760 600",
    viewBoxTblt:"0 0 1108 570",
    viewBoxMbl:"0 0 800 640"
  });

  maskArray = {circles: circlesMask};

  $('.banner__mask--yes').each(function(){

    var maskType = $(this)[0].dataset.masktype;
    var imagePath = $(this)[0].dataset.maskimage;

    var clipPathDsk = maskArray[maskType].clipPathDsk;
    var clipPathTblt = maskArray[maskType].clipPathTblt;
    var clipPathMbl = maskArray[maskType].clipPathMbl;
    var viewBoxDsk = maskArray[maskType].viewBoxDsk;
    var viewBoxTblt = maskArray[maskType].viewBoxTblt;
    var viewBoxMbl = maskArray[maskType].viewBoxMbl;

    var svgMaskDsk = `<svg class="clip-mask--dsk" viewBox="${viewBoxDsk}">
      <defs><clipPath id="mask">${clipPathDsk}</clipPath></defs>
      <image class="banner__mask-image" href="${imagePath}" alt=""/>
    </svg>`;

    var svgMaskTblt = `<svg class="clip-mask--tblt" viewBox="${viewBoxTblt}">
      <defs><clipPath id="tablet-mask">${clipPathTblt}</clipPath></defs>
      <image class="banner__mask-image" href="${imagePath}" alt=""/>
    </svg>`;

    var svgMaskMbl = `<svg class="clip-mask--mbl" viewBox="${viewBoxMbl}">
      <defs><clipPath id="mobile-mask">${clipPathMbl}</clipPath></defs>
      <image class="banner__mask-image" href="${imagePath}" alt=""/>
    </svg>`;

    $(this).append(svgMaskDsk, svgMaskTblt, svgMaskMbl);

  });

  //Offset Homepage Banner if global nav items are present when using Transparent Nav.
  // if ($(window).width() > 1024) {
  //   if ($('.transparent-nav .global-nav.desktop .global-nav__links li').length >= 1) {
  //     console.log("Global nav is present.");
  //     $('.global-nav.desktop ').height(function (index, height) {
  //       $('.banner').css("margin-top", height);
  //       console.log("Added" + " " + height + "px margin-top to banner");
  //     });
  //   }
  // }

  //Offset Header if Alerts are present when using Transparent Nav.
  if ($(window).width() > 1024) {
    if ($('.transparent-nav .alerts').length >= 1) {
      console.log("Alerts is present.");
      $('.alerts').height(function (index, height) {
        $('.header').css("margin-top", height);
        console.log("Added" + " " + height + "px margin-top to banner");
      });
    }
  }

});